import {mapState} from 'vuex'

export default {
    computed: {
        ...mapState({
            formTypes: state => state.expense_form_types
        })
    },
    
    mounted() {
        if(!this.formTypes.length) {
            this.$store.dispatch('fetchExpenseFormTypes');
        }
    }

}